import React from 'react';

// tslint:disable max-line-length
const RIntroContentRemotePersonalTranscriptionBrighton: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. So you’re the one getting the gift. Lucky.  I know someone has been thinking about you. Um...let me explain. Someone you know has visited the museum. You were the lens for everything they looked at. They searched out things they thought you would care about and they took photos and made messages. This is kind of between you two, and the objects they chose, so I’m not going to say much more. I’ll see you on the other side.</p>
  </>
);

export {
  RIntroContentRemotePersonalTranscriptionBrighton,
};
